var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.188 6-2 10h2V9h18v7h2l-2-10h-18z",
    fill: "#f39c12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3.188 9-2 14h22l-2-14h-18z",
    fill: "#e67e22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 2v5H6v1h.031L12 14.5 17.969 8 18 7.9V7h-3V2H9z",
    fill: "#2c3e50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.188 16v7h22v-7H15c-.417 1.1-1.512 2-2.813 2-1.301 0-2.397-.9-2.812-2H1.186z",
    fill: "#f1c40f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f39c12",
    d: "M1.188 23h22v1h-22z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0v6.969H6l6 6.531 6-6.531h-3V0H9z",
    fill: "#34495e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropFolder);
export default __webpack_public_path__ + "static/media/dropFolder.56389495b6efc0d6fdc333913fc6ba8a.svg";
export { ForwardRef as ReactComponent };